exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".type--text-thin--JoEtCVxk {\r\n  font-weight: 100;\r\n}\r\n\r\n.type--text-roman--1Esk5ogR {\r\n  font-weight: 400;\r\n}\r\n\r\n.type--text-bold--3Io0IrFu {\r\n  font-weight: 700;\r\n}\r\n\r\n.type--text-xsmall--2g0tzXOf {\r\n  font-size: 0.5rem;\r\n}\r\n\r\n.type--text-small--9bzsLSr0 {\r\n  font-size: 0.8rem;\r\n}\r\n\r\n.type--text-medium--3G_IKkvq {\r\n  font-size: 1rem;\r\n}\r\n\r\n.type--text-large--qAirIA34 {\r\n  font-size: 1.5rem;\r\n}\r\n\r\n.type--text-xlarge--2l4vlNpz {\r\n  font-size: 3rem;\r\n}", ""]);

// exports
exports.locals = {
	"text-thin": "type--text-thin--JoEtCVxk",
	"text-roman": "type--text-roman--1Esk5ogR",
	"text-bold": "type--text-bold--3Io0IrFu",
	"text-xsmall": "type--text-xsmall--2g0tzXOf",
	"text-small": "type--text-small--9bzsLSr0",
	"text-medium": "type--text-medium--3G_IKkvq",
	"text-large": "type--text-large--qAirIA34",
	"text-xlarge": "type--text-xlarge--2l4vlNpz"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"modules":true,"localIdentName":"[name]--[local]--[hash:base64:8]"}!./src/styles/type.css
// module id = 215
// module chunks = 1